export default __webpack_public_path__ + "static/media/cadeaux-0.db14ee5a.jpeg";